import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useUserContext } from "../context/user_context";
import { API_BASE_URL } from '../utils/apiConfig';
import { useHistory } from 'react-router-dom';
import Alert from '../components/Alert';
import AobList from '../components/AobList';

function AddAob() {

  const history = useHistory();
  const { isLoggedIn, user, login } = useUserContext();
  const [alert, setAlert] = useState({ show: false, msg: '', type: '' });
  const [isEditing, setIsEditing] = useState(false);
  const [area, setArea] = useState('');
  const [sourceSystem, setSourceSystem] = useState('WEB');
  const [referredBy, setReferredBy] = useState(user.results.userId);
  const [list, setList] = useState([]);
  const [formData, setFormData] = useState({
    area: '',
    membershipId: user.results.userAccounts[0].membershipId,
    sourceSystem: 'WEB',
  });

  useEffect(() => {
    fetchAob();
  }, [user]);

  const fetchAob = async () => {
    try {
      const apiUrl = `${API_BASE_URL}/aob/all`;
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${user?.results?.token}`,
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('Failed to fetch subscribers');
      }

      const data = await response.json();
   
      setList(data?.results);

    } catch (error) {
      console.error(error);

    }
  };


  const removeItem = async (id) => {
    try {
      const apiUrl = `${API_BASE_URL}/aob/${id}`;
      const response = await fetch(apiUrl, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${user?.results?.token}`,
        },
      });

      if (response.ok) {
        // Handle successful response
        const responseData = await response.json();
        showAlert(true, 'success', responseData.message);

        // After successful deletion, you might want to update the list state
        // with the remaining employees excluding the deleted one.
        setList((prevList) => prevList.filter((item) => item.id !== id));
      } else {
        // Handle error response
        const errorResponse = await response.json();
        showAlert(true, 'danger', errorResponse.message);
      }
    } catch (error) {
      // Handle any other errors during the process
      console.error('Error:', error);
      showAlert(true, 'danger', 'Error occurred while deleting');
    }
  };
  const editItem = (id) => {

  };



  const handleSubmit = async (e) => {
    e.preventDefault();
 
    //console.log(...formData);
    const apiUrl = `${API_BASE_URL}/aob`;
    if (!formData.area) {
      showAlert(true, 'danger', 'please enter value');
    } else if (formData.area && isEditing) {

      showAlert(true, 'success', 'value changed');
    } else {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${user?.results?.token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData
        }),
      });
   
     const responseData = await response.json();
  
     
      if (response.ok) {
        // Handle successful response
        
        showAlert(true, 'success', responseData.message);
        fetchAob();
        // Reset form data after successful submission
        setFormData({
          area: '',
          membershipId: user.results.userAccounts[0].membershipId,
          sourceSystem: 'WEB',

        });


      } else {
        // Handle error response        
        showAlert(true, 'danger', responseData.errors|| responseData.message || "An error occurred");
      }

    }
  };



  const showAlert = (show = false, type = '', msg = '') => {
    setAlert({ show, type, msg });
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  //const isButtonDisabled = !formData.firstName;
  return (
    <Wrapper >

      <form className='aob-form' onSubmit={handleSubmit} >
        {alert.show && <Alert {...alert} removeAlert={showAlert} list={list} />}
        <h3>Add Area of Business </h3>
        <h4>Total Area Added:({list.length})</h4>
        <div className='form-control' >

          <input
            type='text'
            className='aob'
            placeholder='e.g. Coimbatore'
            name="area"
            value={formData.area} onChange={handleChange}

          />
          <button type='submit' className='submit-btn'>
            {isEditing ? 'edit' : 'add'}
          </button>
        </div>
      </form>
      {list.length > 0 && (
        <div className='aob-container'>
          <AobList items={list} removeItem={removeItem} editItem={editItem} />
          <button className='clear-btn' >
            clear items
          </button>
        </div>
      )}

    </Wrapper>
  );
}
const Wrapper = styled.section`
display: flex;
flex-direction: column;
.form-control {    
    display: flex;
    justify-content: center;
    // this is making the text box to be centered
    padding: 0rem 15rem;

  }    
  .aob-form h3 {
    color: var(--clr-primary-1);
    margin-bottom: 1.5rem;
    text-align: center;
  }
  .form-control {
    display: flex;
    justify-content: center;
  }
  .aob {
    padding: 0.25rem;
    padding-left: 1rem;
    background: var(--clr-grey-10);
    border-top-left-radius: var(--radius);
    border-bottom-left-radius: var(--radius);
    border-color: transparent;
    font-size: 1rem;
    flex: 1 0 auto;
    color: var(--clr-grey-5);
  }
  
  .aob::placeholder {
    font-family: var(--ff-secondary);
    color: var(--clr-grey-5);
  }
  
  .submit-btn {
    background: var(--clr-red-dark);
    border-color: transparent;
    flex: 0 0 5rem;
    display: grid;
    align-items: center;
    padding: 0.25rem;
    text-transform: capitalize;
    letter-spacing: 2px;
    border-top-right-radius: var(--radius);
    border-bottom-right-radius: var(--radius);
    cursor: pointer;
    content: white;
    transition: var(--transition);
    font-size: 0.85rem;
    color: var(--clr-white);
  }
  
  .submit-btn:hover {
    background: var(--clr-primary-5);
    color: var(--clr-white);
  }
  
  .alert {
    margin-bottom: 1rem;
    height: 1.25rem;
    display: grid;
    align-items: center;
    text-align: center;
    font-size: 0.7rem;
    border-radius: 0.25rem;
    letter-spacing: var(--spacing);
    text-transform: capitalize;
    padding :0rem 15rem;
  }
  
  .alert-danger {
    color: #721c24;
    background: #f8d7da;
  }
  
  .alert-success {
    color: #155724;
    background: #d4edda;
  }

// to diplay list

.aob-container {
    margin-top: 2rem;
    padding :0rem 10rem;
  }

  .aob-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    transition: var(--transition);
    padding: 0.25rem 1rem;
    border-radius: var(--radius);
    text-transform: capitalize;
  }
  
  .aob-item:hover {
    color: var(--clr-grey-5);
    background: var(--clr-grey-10);
  }
  
  .aob-item:hover .title {
    color: var(--clr-grey-5);
  }
  
  .title {
    margin-bottom: 0;
    color: var(--clr-grey-1);
    letter-spacing: 2px;
    transition: var(--transition);
  }
  
  .edit-btn,
  .delete-btn {
    background: transparent;
    border-color: transparent;
    cursor: pointer;
    font-size: 0.7rem;
    margin: 0 0.15rem;
    transition: var(--transition);
  }
  
  .edit-btn {
    color: var(--clr-green-light);
  }
  
  .edit-btn:hover {
    color: var(--clr-green-dark);
  }
  
  .delete-btn {
    color: var(--clr-red-light);
  }
  
  .delete-btn:hover {
    color: var(--clr-red-dark);
  }
  
  .clear-btn {
    text-transform: capitalize;
    width: 10rem;
    height: 1.5rem;
    display: grid;
    align-items: center;
    background: transparent;
    border-color: transparent;
    color: var(--clr-red-light);
    margin: 0 auto;
    font-size: 0.85rem;
    letter-spacing: var(--spacing);
    cursor: pointer;
    transition: var(--transition);
    margin-top: 1.25rem;
  }
  
  .clear-btn:hover {
    color: var(--clr-red-dark);
  }

`
export default AddAob;
